import React, { useState, useEffect } from "react";
import Reveal from "./Reveal";
import { ArrowLeft, ArrowRight } from "lucide-react";

const testimonials = [
  {
    id: "t1",
    quote:
      "Working with Dot Media across multiple campaigns has been a delight they understand my vision like a well-trained sous-chef. Every project was thoughtfully crafted, beautifully presented, and consistently delivered with excellence.",
    author: "Aanya Rao",
    role: "Founder · Lumen Skincare",
    img: "/images/img1.png",
  },
];

const Testimonials = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setI((v) => (v + 1) % testimonials.length),
      6500,
    );
    return () => clearInterval(id);
  }, []);

  const t = testimonials[i] ?? testimonials[0];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-white pt-20 md:pt-28 pb-20 md:pb-28 border-t border-black/10"
    >
      <div className="px-6 md:px-12 lg:px-16">
        {/* ── Header ── */}
        <div className="mb-10 md:mb-14">
          <p className="flex items-center gap-2 text-[12px] tracking-[0.28em] uppercase font-bold text-[#E60000] mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E60000]" />
            Voices
          </p>
          <Reveal>
            <h2
              data-testid="testimonials-heading"
              className="font-display font-black uppercase text-[36px] sm:text-[52px] md:text-[64px] leading-[0.95] tracking-tighter text-black"
            >
              Trusted by brands
              <br />
              that aim higher<span className="text-[#E60000]">.</span>
            </h2>
          </Reveal>
        </div>

        {/* ── Testimonial Body ── */}
        <div className="border-t border-b border-black/15 py-10 md:py-16">
          <div className="flex flex-col md:flex-row md:items-start gap-10 md:gap-12 lg:gap-16">
            {/* LEFT — Quote block */}
            <div className="flex-1 min-w-0">
              {/* Opening quote mark */}
              <span className="block font-display font-black text-[#E60000] text-[80px] md:text-[100px] leading-none -mb-2 md:-mb-4">
                &#8220;
              </span>

              {/* Quote text */}
              <Reveal key={t.id}>
                <p
                  data-testid="testimonial-quote"
                  className="font-display font-medium text-[26px] sm:text-[32px] md:text-[44px] leading-[1.1] tracking-tight text-black"
                >
                  {t.quote}
                </p>
              </Reveal>

              {/* Author */}
              <div className="mt-8 flex flex-wrap items-center gap-3 text-sm tracking-[0.18em] uppercase font-semibold text-black">
                <span data-testid="testimonial-author">{t.author}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#E60000] shrink-0" />
                <span className="text-black/60">{t.role}</span>
              </div>
            </div>

            {/* RIGHT — Image + Nav */}
            <div className="flex flex-col items-center md:items-end gap-5 w-full md:w-auto shrink-0">
              {/* Portrait image */}
              <div className="relative w-full max-w-[260px] md:w-[260px] lg:w-[300px] aspect-[2/3] overflow-hidden bg-[#F0F0F0]">
                <img
                  key={t.id}
                  src={t.img}
                  alt={t.author}
                  className="w-full h-full object-cover object-top transition-opacity duration-500"
                />
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#E60000]" />
              </div>

              {/* Nav arrows */}
              <div className="flex items-center gap-2 self-end md:self-auto">
                <button
                  aria-label="Previous"
                  data-testid="testimonial-prev"
                  onClick={() =>
                    setI(
                      (v) =>
                        (v - 1 + testimonials.length) % testimonials.length,
                    )
                  }
                  className="w-10 h-10 border border-black/30 hover:bg-black hover:text-white transition-colors flex items-center justify-center"
                >
                  <ArrowLeft size={16} />
                </button>
                <button
                  aria-label="Next"
                  data-testid="testimonial-next"
                  onClick={() => setI((v) => (v + 1) % testimonials.length)}
                  className="w-10 h-10 border border-black/30 hover:bg-[#E60000] hover:border-[#E60000] hover:text-white transition-colors flex items-center justify-center"
                >
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
